import { type UploadSize } from "@components/atoms/Upload";
import { CommonElementType } from "@utils/DynamicComponentUtils";
import { type CommonContentsRenderType, type CommonCreateBodyKeyType, type CommonDataType } from "src/types/common";
import { ICONS } from "@assets/icons";
import Noti from "@components/atoms/Noti";
import { V2EventCreateRequestDtoCategory } from "@everon-it/api-client/contents-gw";
import { DateUtil } from "@everon-it/core";

type EventCreateInitValuesType = {
    title: string;
    isVisible: boolean;
    eventStartAt: string;
    eventEndAt: string;
    displayStartAt: string;
    displayEndAt: string;
    thumbnailUrl: string;
    contentCategory: string;
    category: string;
    content: string;
    urls: { title: string; url: string }[] | undefined;
    url: string;
};

export type EventCommonContentsOptionType = {
    size?: UploadSize;
    isSizeQuestion?: boolean;
    secondName?: string;
    placeholder?: string;
    secondPlaceholder?: string;
    notice?: JSX.Element;
} & CommonContentsRenderType;

export const EventNoti = <Noti iconSrc={ICONS.NOTI_ICON.LIGHT_BULB} text="기간 내 이벤트는 진행중인 건으로 표출되며, 기간이 끝난 이벤트는 지난 이벤트로 표출됩니다." />;

export const EventCreateData: CommonDataType<CommonCreateBodyKeyType, EventCreateInitValuesType, EventCommonContentsOptionType> = {
    createBodyKey: ["title", "category", "isVisible", "eventStartAt", "eventEndAt", "displayStartAt", "displayEndAt", "thumbnailUrl", "urls", "content"],
    formInitialValues: {
        title: "",
        isVisible: false,
        eventStartAt: DateUtil.getToday(),
        eventEndAt: "",
        displayStartAt: DateUtil.getToday(),
        displayEndAt: "",
        thumbnailUrl: "",
        contentCategory: V2EventCreateRequestDtoCategory.CONTENT,
        category: "",
        content: "",
        urls: undefined,
        url: "",
    },
    contentsOption: [
        {
            label: "게시 날짜",
            name: "displayStartAt",
            secondName: "displayEndAt",
            type: CommonElementType.DATE_RANGE_PICKER,
            placeholder: "날짜를 입력해주세요",
            secondPlaceholder: "날짜를 입력해주세요",
        },
        {
            label: "노출 상태",
            name: "isVisible",
            type: CommonElementType.TOGGLE,
        },
        {
            label: "썸네일 이미지",
            name: "thumbnailUrl",
            type: CommonElementType.IMAGE_UPLOAD,
            size: "medium",
            isSizeQuestion: true,
        },
        {
            label: "제목",
            name: "title",
            type: CommonElementType.INPUT,
            placeholder: "제목을 입력해주세요",
        },
        {
            label: "이벤트 기간",
            name: "eventStartAt",
            secondName: "eventEndAt",
            type: CommonElementType.DATE_RANGE_PICKER,
            placeholder: "날짜를 입력해주세요",
            secondPlaceholder: "날짜를 입력해주세요",
            notice: EventNoti,
        },
        {
            label: "내용",
            name: "contentCategory",
            type: CommonElementType.RADIO,
            options: [
                { label: "직접작성", value: V2EventCreateRequestDtoCategory.CONTENT },
                { label: "URL 연결", value: V2EventCreateRequestDtoCategory.URL },
                { label: "이벤트 버튼 생성", value: V2EventCreateRequestDtoCategory.BUTTON },
            ],
        },
    ],
};
